import { createReduxAsyncAction } from '../utils/toolkit';
import { TYPES } from './constants';

export const loadUsers = createReduxAsyncAction(TYPES.LOAD_USERS);
export const loadUsersFavorites = createReduxAsyncAction(TYPES.LOAD_USERS_FAVORITES);
export const loadFilterUsers = createReduxAsyncAction(TYPES.LOAD_FILTER_USERS);
export const loadTenantWorkers = createReduxAsyncAction(TYPES.LOAD_TENANT_WORKERS);
export const loadTenantSupporters = createReduxAsyncAction(TYPES.LOAD_TENANT_SUPPORTERS);
export const loadLinemenByLocation = createReduxAsyncAction(TYPES.LOAD_INVITED_LINEMEN_BY_LOCATION);
export const loadUserFavorites = createReduxAsyncAction(TYPES.LOAD_USER_FAVORITES);
export const notifyUsers = createReduxAsyncAction(TYPES.NOTIFY_USERS);
export const loadAvailableSharedUsers = createReduxAsyncAction(TYPES.LOAD_AVAILABLE_SHARED_USERS);
export const loadUsersWithTenant = createReduxAsyncAction(TYPES.LOAD_USERS_TENANT);
export const bulkUploadUsers = createReduxAsyncAction(TYPES.BULK_UPLOAD_USERS);
export const loadPossibleRosterOwners = createReduxAsyncAction(TYPES.LOAD_POSSIBLE_ROSTER_OWNERS);
